// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M9CmWQ1zbMTBWoN93sjr{color:var(--content-primary-primary-inverted);background:#2a2e31;border-radius:6px;gap:8px;padding:8px 12px;display:flex}.M9CmWQ1zbMTBWoN93sjr.tycu3ab9AoU2_QYXsUuD{background:var(--content-primary-disabled)}.M9CmWQ1zbMTBWoN93sjr{box-shadow:0 1px 2px rgba(18,21,23,.12)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `M9CmWQ1zbMTBWoN93sjr`,
	"disabled": `tycu3ab9AoU2_QYXsUuD`
};
export default ___CSS_LOADER_EXPORT___;
